import React from 'react'

const ConfidentialFiles = () => {
  return (
    <div>ConfidentialFiles</div>
  )
}

export default ConfidentialFiles